"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dataGridContext = require("../../data-grid-context");

var helpers = _interopRequireWildcard(require("./filter-selector/filter-selector-helpers"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _first = _interopRequireDefault(require("lodash/first"));

require("./lang");

var _styles = require("@eig-builder/core-ui/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    filterBar: {
      padding: "8px",
      boxShadow: "rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px",
      "& .filters": {
        margin: "0",
        padding: "0",
        "& li": {
          display: "inline-block",
          marginRight: "8px"
        },
        "& .filter-item": {
          backgroundColor: "#EBEBEB",
          borderRadius: "15px",
          padding: "4px"
        },
        "& .filter-close, & .filter-title": {
          display: "inline-block",
          verticalAlign: "middle"
        },
        "& .filter-close": {
          transform: "rotate(45deg)",
          marginLeft: "-4px",
          cursor: "pointer",
          height: "24px",
          "&:hover": {
            i: {
              color: "$primitive-text-disabled-hint !important"
            }
          }
        },
        "& .filter-title": {
          marginLeft: "8px",
          marginRight: "2px"
        }
      }
    }
  };
});

var FilterBar = function FilterBar(props) {
  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      filterSelectorHeaders = _useDataGridContext.filterSelectorHeaders,
      setFilterSelectorActive = _useDataGridContext.setFilterSelectorActive;

  var closeFilter = function closeFilter(item, filtertype) {
    // reconstitute filters based on selection
    var existingFilter = (0, _first["default"])(props.filters.filter(function (f) {
      return f.name === item.name && f.filterType === 'filter-selector';
    }));
    var newFilters = props.filters.filter(function (f) {
      return f.name !== item.name && f.filterType === 'filter-selector';
    });

    if (existingFilter.value === 'both') {
      var newFilter = filtertype === 0 ? helpers.createQueryFilter(item, 1) : helpers.createQueryFilter(item, 0);
      newFilters.push(newFilter);
    }

    if (Array.isArray(newFilters) && newFilters.length) {
      setFilterSelectorActive(true);
    } else {
      setFilterSelectorActive(false);
    }

    props.setFilters(newFilters);
  };

  var boolTrueInFilterBar = function boolTrueInFilterBar(index, item) {
    return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
      key: index,
      className: "filter-item"
    }, (0, _taggingHelper.getDataProperty)({
      dataElementType: _taggingHelper.DataElementTypes.BUTTON,
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "filter-close-true-".concat(props.tag),
      dataElementId: "filter-close-true-".concat(props.tag)
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter-close",
      onClick: function onClick() {
        return closeFilter(item, 1);
      }
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "material-icons md-dark"
    }, "add_circle")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter-title"
    }, item.title));
  };

  var boolFalseInFilterBar = function boolFalseInFilterBar(index, item) {
    return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
      key: -index,
      className: "filter-item"
    }, (0, _taggingHelper.getDataProperty)({
      dataElementType: _taggingHelper.DataElementTypes.BUTTON,
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "filter-close-false-".concat(props.tag),
      dataElementId: "filter-close-false-".concat(props.tag)
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter-close",
      onClick: function onClick() {
        return closeFilter(item, 0);
      }
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "material-icons md-dark"
    }, "add_circle")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter-title"
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "core.components.datatable.filter.not"
    }), item.title)));
  };

  var renderFiltersInBar = function renderFiltersInBar() {
    var returnItems = [];
    filterSelectorHeaders.forEach(function (item, index) {
      if ([1, 2].includes(item.filterType)) {
        returnItems.push(boolTrueInFilterBar(index, item));
      }

      if ([0, 2].includes(item.filterType)) {
        returnItems.push(boolFalseInFilterBar(index, item));
      }
    });
    returnItems.push( /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      color: "secondary",
      onClick: function onClick() {
        setFilterSelectorActive(false);
        props.setFilters([]);
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "clear-filters",
      dataElementId: 'clear-filters-' + props.tag
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "core.components.datatable.filter.clear"
    }))));
    return returnItems;
  };

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.filterBar
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "filters"
  }, renderFiltersInBar()));
};

FilterBar.propTypes = {
  tag: _propTypes["default"].string,
  filters: _propTypes["default"].array,
  setFilters: _propTypes["default"].func
};
var _default = FilterBar;
exports["default"] = _default;